import CONFIG from '@config';
import querystring from 'query-string';

const geocode = (params = {}) => {
  const defaultOptions = {
    key: CONFIG.google_apis.browser_key,
  };
  const query = querystring.stringify({
    ...defaultOptions,
    ...params,
  });

  return fetch(`https://maps.googleapis.com/maps/api/geocode/json?${query}`)
    .then(r => r.json());
};

export default geocode;
